module.exports = __webpack_public_path__ + "img/mowerwalk_driving.bea6dff9.svg";